var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-sub-title"},[_c('span',{staticClass:"u-sub-title__header"},[_vm._v(_vm._s(_vm.innerText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }